<template>
    <section class="header-nav" ref="headerNav" v-cloak>
        <v-app-bar app id="header-1" height="80" ref="homeMenuHeader">
            <div class="container homes-menu-right">
                <div class="homes-menu-right-top">
                     <div class="header-logo-box">
                        <v-toolbar-title class="headline text-uppercase">
                            <div class="header-logo d-flex align-items-center">
                                <a href="/" @click.prevent="on_click_logo" aria-label="重新加载素材库首页" class="logo-link"
                                    ><img class="name" src="/dist/img/Logo.png" alt="素材库 Logo"
                                /></a>
                            </div>
                        </v-toolbar-title>
                        <v-btn icon @click="on_toggle_menu" aria-label="切换左侧分类导航栏">
                            <v-icon v-if="!isMenuHide">mdi-menu-open</v-icon>
                            <v-icon v-else>mdi-menu-close</v-icon>
                        </v-btn>
                    </div>
                    <div class="header-sear d-flex flex-column justify-content-start">
                        <div class="header-search" ref="headerSearchBox" @click="on_toggle_search_input">
                            <v-icon>mdi-magnify</v-icon>
                            <input
                                type="text"
                                placeholder="请输入关键词"
                                ref="searText"
                                v-model.trim="keyword"
                                @keyup.enter="on_click_search_btn"
                                @input="
                                    keyword == ''
                                        ? (isDisabledSearch = true)
                                        : (isDisabledSearch = false)
                                "
                            />
                            <v-btn
                                icon
                                small
                                class="header-search-clear"
                                v-if="keyword && keyword.length > 0"
                                @click.stop="on_clear_search_keyword"
                                title="清空关键词"
                            >
                                <v-icon small>mdi-close-circle</v-icon>
                            </v-btn>
                            <v-btn icon class="header-search-more" v-if="searchMove">
                                <v-icon class="fa fa-sort-down">mdi-chevron-down</v-icon>
                            </v-btn>
                            <v-btn icon class="close" @click="search_big_box_close" v-else>
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </div>
                        <div class="searchbigbox" ref="searchBigBox" @click="search_big_box_show">
                            <!-- 按日期 -->
                            <div class="_uptimes_box">
                                <div class="_uptimes">
                                    <div class="_uptimes_title">按日期</div>
                                    <v-select
                                        append-icon="mdi-chevron-down"
                                        @change="on_chang_time_type"
                                        v-model="timeModel"
                                        :items="timeListItems"
                                        item-text="text"
                                        item-value="value"
                                        :label="timeModel.value"
                                        :timeFormat="timeModel.value"
                                        return-object
                                        single-line
                                        color="#106951"
                                        item-color="#106951"
                                        dense
                                        :outlined="false"
                                    ></v-select>
                                </div>
                                <div class="_choose_time_box" ref="chooseTimeBox">
                                    <div class="_choose_time">
                                        <div class="_choose_time_title">日期范围：</div>
                                        <div class="_choose_time_btn">
                                            <!-- 开始时间 -->
                                            <v-menu
                                                ref="startMenu"
                                                class="start-menu"
                                                :close-on-content-click="false"
                                                :return-value.sync="trip.start"
                                                offset-y
                                                transition="scale-transition"
                                                min-width="290px"
                                            >
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field
                                                        ref="startField"
                                                        v-model="trip.start"
                                                        clearable
                                                        label="开始日期"
                                                        prepend-icon="mdi-calendar"
                                                        readonly
                                                        v-on="on"
                                                        color="#106951"
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker locale="zh-cn"
                                                    v-model="date"
                                                    no-title
                                                    scrollable
                                                    color="#106951"
                                                >
                                                    <v-spacer></v-spacer>
                                                    <v-btn
                                                        text
                                                        color="#106951"
                                                        @click="startMenu = false"
                                                        >Cancel</v-btn
                                                    >
                                                    <v-btn
                                                        text
                                                        color="#106951"
                                                        class="start-date-change"
                                                        @click="$refs.startMenu.save(date)"
                                                        >OK</v-btn
                                                    >
                                                </v-date-picker>
                                            </v-menu>
                                            <!-- 结束时间 -->
                                            <v-menu
                                                ref="endMenu"
                                                class="end-menu"
                                                :close-on-content-click="false"
                                                :return-value.sync="trip.end"
                                                offset-y
                                                transition="scale-transition"
                                                min-width="290px"
                                            >
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field
                                                        v-model="trip.end"
                                                        clearable
                                                        ref="endField"
                                                        label="结束日期"
                                                        prepend-icon="mdi-calendar"
                                                        readonly
                                                        v-on="on"
                                                        color="#106951"
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker locale="zh-cn"
                                                    v-model="date"
                                                    no-title
                                                    scrollable
                                                    color="#106951"
                                                >
                                                    <v-spacer></v-spacer>
                                                    <v-btn
                                                        text
                                                        color="#106951"
                                                        @click="$refs.endMenu.isActive = false"
                                                        >Cancel</v-btn
                                                    >
                                                    <v-btn
                                                        text
                                                        color="#106951"
                                                        class="end-date-change"
                                                        @click="$refs.endMenu.save(date)"
                                                        >OK</v-btn
                                                    >
                                                </v-date-picker>
                                            </v-menu>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- 按类型筛选 -->
                            <div class="_type_box">
                                <div class="_type">
                                    <div class="_type_title">按类型</div>
                                    <v-select
                                        append-icon="mdi-chevron-down"
                                        :value="SearchTypeSelect"
                                        :items="filterTypeItems"
                                        @input="on_change_search_select"
                                        item-text="text"
                                        item-value="value"
                                        :label="SearchTypeSelect.value"
                                        return-object
                                        single-line
                                        color="#106951"
                                        item-color="#106951"
                                        dense
                                        :outlined="false"
                                    ></v-select>
                                </div>
                            </div>
                            <!-- 选择分类 -->
                            <div class="_category_box">
                                <div class="_category">
                                    <div class="_category_title">按分类</div>
                                    <div
                                        class="_category_unlimited search_text"
                                        @click="on_click_category_btn"
                                    >
                                        <span data-code="all" ref="categoryInput">{{
                                            isUnlimited ? "不限位置" : "已选分类……"
                                        }}</span>
                                        <v-icon>mdi-chevron-down</v-icon>
                                    </div>
                                </div>
                                <!-- 分类下拉框 -->
                                <div class="_category_list all_list scrollbar" ref="categoryList" @click="search_change_show">
                                    <div class="_langtext menu-item">
                                        <v-checkbox
                                            :disabled="isUnlimited"
                                            dense
                                            v-model="isUnlimited"
                                            label="不限位置"
                                            color="#106951"
                                            @change="on_change_all_checked"
                                        ></v-checkbox>
                                    </div>
                                    <v-list>
                                        <template>
                                            <v-treeview
                                                :items="newNavData"
                                                item-key="fileId"
                                                item-children="lv1_categories"
                                                @input="on_checked_item"
                                                v-model="selection"
                                                hoverable
                                                selectable
                                                selected-color="#106951"
                                            ></v-treeview>
                                        </template>
                                    </v-list>
                                </div>
                            </div>
                            <!-- 下载量过滤 -->
                            <div class="_type_box">
                                <div class="_type">
                                    <div class="_type_title">下载量</div>
                                    <div class="download-range">
                                        <vue-numeric
                                            currency=""
                                            separator=","
                                            v-model="download_start"
                                            :min="0"
                                            :allowClear="false"
                                        ></vue-numeric>
                                        <span>~</span>
                                        <vue-numeric
                                            currency=""
                                            separator=","
                                            v-model="download_end"
                                            :max="MAX_DOWNLOAD_END"
                                            :allowClear="false"
                                        ></vue-numeric>
                                    </div>
                                </div>
                            </div>
                            <!-- 搜索按钮 -->
                            <div class="_btton">
                                <v-btn
                                    depressed
                                    class="_export"
                                    @click="on_export"
                                    :loading="exporting"
                                    :disabled="isUnlimited || timeModel.value === 'all'"
                                >
                                    导出
                                </v-btn>
                                <v-btn depressed class="_reset" @click="on_reset_search_filter">重置</v-btn>
                                <v-btn
                                    class="_sech"
                                    @click="on_click_search_btn"
                                    @keyup.enter="on_click_search_btn"
                                    :disabled="isDisabledSearch"
                                    ref="_sech"
                                    >搜索</v-btn
                                >
                            </div>
                        </div>
                    </div>
                    <v-spacer></v-spacer>
                    <!-- 最新素材按钮 -->
                    <v-btn @click.stop.prevent="on_show_latest_materials" class="feedback-box" depressed text :height="36">
                        <v-icon>mdi-fire</v-icon> 最新素材
                    </v-btn>
                    <!-- 通知按钮 -->
                    <v-btn v-for="notice in notices.data" depressed text :height="36" class="feedback-box" :key="notice.id">
                        <a :href="notice.content" target="_blank" rel="noopener noreferrer">
                            <v-icon>mdi-tooltip-text-outline</v-icon>{{ notice.name }}
                        </a>
                    </v-btn>

                    <!-- 用户信息胶囊与退出登录下拉菜单 -->
                    <div class="header-user-area">
                        <span class="header-user-divider" aria-hidden="true"></span>
                        <v-menu
                            offset-y
                            bottom
                            left
                            transition="slide-y-transition"
                            :close-on-content-click="false"
                            content-class="user-dropdown-menu"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <button
                                    type="button"
                                    class="user-capsule-btn"
                                    v-bind="attrs"
                                    v-on="on"
                                    aria-label="当前账号与退出登录菜单"
                                >
                                    <span class="user-avatar-badge">
                                        {{ userInitial }}
                                    </span>
                                    <span class="user-name-text">
                                        {{ currentUser.name || "账号" }}
                                    </span>
                                    <v-icon small class="user-caret-icon">mdi-chevron-down</v-icon>
                                </button>
                            </template>

                            <div class="user-menu-card">
                                <div class="user-menu-header">
                                    <div class="user-menu-avatar">
                                        {{ userInitial }}
                                    </div>
                                    <div class="user-menu-info">
                                        <div class="user-menu-name">{{ currentUser.name || "已登录用户" }}</div>
                                        <div class="user-menu-email" v-if="currentUser.email">{{ currentUser.email }}</div>
                                    </div>
                                </div>
                                <div class="user-menu-divider"></div>
                                <button
                                    type="button"
                                    class="user-logout-btn"
                                    :disabled="loggingOut"
                                    @click="on_logout"
                                >
                                    <v-icon small class="logout-icon">mdi-logout-variant</v-icon>
                                    <span>{{ loggingOut ? "正在退出..." : "退出登录" }}</span>
                                </button>
                            </div>
                        </v-menu>
                    </div>
                </div>
            </div>
        </v-app-bar>
    </section>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { get_api_data } from "@/utils/ajax";
import VueNumeric from "vue-numeric";
import qs from "qs";

const MAX_DOWNLOAD_END = 9_9999;

export default {
    name: "header-nav",
    props: {
        webIamge: {
            type: String,
        },
    },
    components: {
        VueNumeric,
    },
    data() {
        return {
            isMenuHide: false,
            navInfos: [],
            basicInfo: [],
            feedback_link: "",
            newNavData: [],
            provisional: {},
            notices: [],
            selection: [],
            timeModel: { value: "all" },
            timeListItems: [
                { text: "不限日期", value: "all" },
                { text: "今天", value: "nowadays" },
                { text: "昨天", value: "yesterday" },
                { text: "最近7天", value: "weekTime" },
                { text: "最近30天", value: "monthTime" },
                { text: "自行设定", value: "customize" },
            ],
            filterTypeItems: [
                { text: "不限类型", value: "all" },
                { text: "仅图片", value: "image" },
                { text: "仅视频", value: "video" },
            ],
            searchResult: [],
            keyword: "",
            isUnlimited: true,
            oldScrollTop: 0,
            headerSearActive: "header_sear_active",
            sreachActive: " header_searlist_active",
            imageMenuNav: "menu-item",
            ListCurrent: 0,
            ListChildCurrent: 0,
            nowadays: 0,
            weekTime: 0,
            monthTime: 0,
            yesterday: 0,
            download_start: 0,
            download_end: MAX_DOWNLOAD_END,
            MAX_DOWNLOAD_END,
            trip: {
                name: "",
                location: null,
                start: null,
                end: null,
            },
            date: null,
            item: "item",
            searchMove: true,
            // 移除搜索按钮的单击或 target 功能
            isDisabledSearch: true,
            checkBoxDriveIdsID: [],
            checkBoxLv1_ID: [],
            exporting: false,
            isLoadingLatest: false, // 新增控制加载状态，防止重复请求
            currentUser: {
                name: "",
                email: "",
            },
            loggingOut: false,
        };
    },
    computed: {
        ...mapState("global", [
            "SearchTypeSelect",
            "allCardList",
            "allCardListMeta",
            "driveIdsID",
            "lv1_ID",
            "lv2_ID",
            "starTime",
            "endTime",
            "sequenceType",
        ]),
        // 提取用户名首字符用于圆形头像徽章显示
        userInitial() {
            const name = (this.currentUser && this.currentUser.name) ? this.currentUser.name.trim() : "";
            return name ? name.charAt(0).toUpperCase() : "U";
        },
    },
    watch: {
        $route(to) {
            if (to.path !== "/search") {
                this.updateKeyword("");
                this.keyword = null;
            }
            // 确保路由变化时不触发额外请求
            if (this.isLoadingLatest) {
                this.isLoadingLatest = false;
            }
        },
    },
    created() {
        // 全局 / 键极速聚焦搜索框，Esc 退出聚焦
        this._globalSlashHandler = (e) => {
            const targetTag = (e.target && e.target.tagName) ? e.target.tagName.toUpperCase() : "";
            const isInput = targetTag === "INPUT" || targetTag === "TEXTAREA" || (e.target && e.target.isContentEditable);

            if (!isInput && e.key === "/") {
                e.preventDefault();
                if (this.$refs.searText) {
                    this.$refs.searText.focus();
                    this.$refs.searText.select();
                }
            } else if (e.key === "Escape" && document.activeElement === this.$refs.searText) {
                this.$refs.searText.blur();
                this.search_big_box_close();
            }
        };
        window.addEventListener("keydown", this._globalSlashHandler);
        this.get_nav_data();
        this.get_basic_info();
        this.time_change_show();
    },
    mounted() {
        this.$P.$on("resetSearchInput", () => {
            this.keyword = "";
            this.isDisabledSearch = true;
        });
        this.load_search_page();
        window.addEventListener("scroll", this.on_menu_scroll, false);
    },
    beforeDestroy() {
        if (this._globalSlashHandler) {
            window.removeEventListener("keydown", this._globalSlashHandler);
        }
        window.removeEventListener("scroll", this.on_menu_scroll, false);
    },
    methods: {
        // 一键清空搜索关键词并自动重新聚焦
        on_clear_search_keyword() {
            this.keyword = '';
            this.isDisabledSearch = true;
            this.$nextTick(() => {
                if (this.$refs.searText) {
                    this.$refs.searText.focus();
                }
            });
            this.$P.$emit("updateSearchFn", "");
        },
        ...mapMutations("global", [
            "updateNavInfos",
            "updateTypeSelect",
            "updateDriveIdsID",
            "updateLv1_ID",
            "updateLv2_ID",
            "updateStarTime",
            "updateEndTime",
            "updateKeyword",
            "updateAllCardList",
            "updateAllCardListMeta",
            "updateSearchTypeSelect",
            "updateDownloadStart",
            "updateDownloadEnd",
        ]),
        ...mapMutations("batchOperation", ["obj"]),

        // 点击左上角 Logo 重新加载页面并回到首页
        on_click_logo() {
            if (window.location.pathname === '/' && !window.location.search && !window.location.hash) {
                window.location.reload();
            } else {
                window.location.href = '/';
            }
        },

        on_change_search_select(el) {
            this.updateSearchTypeSelect(el.value);
        },
         //  获取导航数据
        async get_nav_data() {
            if (this.navInfos.length > 0) return;
            this.navInfos = await get_api_data("GET", "libraries-menu");
            this.updateNavInfos(this.navInfos.data);
            this.navInfos.data.map((item) => {
                this.provisional = item;
                this.provisional["fileId"] = item["driveId"];
                this.newNavData.push(this.provisional);
            });
        },
         //  获取默认基础数据与当前登录用户信息
        async get_basic_info() {
            this.notices = await get_api_data("GET", "basic-info");
            try {
                const res = await get_api_data("GET", "user-info");
                if (res && res.data) {
                    this.currentUser = res.data;
                }
            } catch (e) {
                console.warn("获取用户信息失败:", e);
            }
        },
        // 退出登录并销毁服务端会话后跳转至登录页
        async on_logout() {
            if (this.loggingOut) return;
            this.loggingOut = true;
            try {
                await get_api_data("POST", "logout");
            } catch (e) {
                console.warn("退出登录请求异常，直接跳转登录页:", e);
            } finally {
                window.location.href = "/login";
            }
        },
         // 点一级导航，跳转到categories页面
        on_goto_lv1_cate_page(driveId) {
            this.$router.push(`/${driveId}`);
        },

        // 点二级导航跳转到列表页
        on_goto_material_list_page(driveId, fileId) {
            if (fileId !== this.$route.params.materialList) {
                this.$router.push(`/${driveId}/${fileId}`);
            } else {
                this.$P.$emit("clickCategoryUpdateImgList");
            }

            this.GLOBAL.scrollPage = 1;
            this.updateAllCardList("");
            this.updateDriveIdsID([driveId]);
            this.updateLv1_ID([fileId]);
        },
        // 新增方法：点击“添加最新上传的素材”按钮展示最新素材
        async on_show_latest_materials() {
            // 防止重复点击触发多次请求
            if (this.isLoadingLatest) return;
            this.isLoadingLatest = true;

            try {
                // 清空现有列表和过滤条件
                this.updateAllCardList("");
                this.updateAllCardListMeta("");
                this.updateDriveIdsID([]);
                this.updateLv1_ID([]);
                this.updateKeyword("");
                this.keyword = "";
                this.updateSearchTypeSelect("all");
                this.updateStarTime("");
                this.updateEndTime("");
                this.updateDownloadStart(0);
                this.updateDownloadEnd(this.MAX_DOWNLOAD_END);
                this.GLOBAL.scrollPage = 1;
                this.get_search_result(this.GLOBAL.scrollPage);

                // 导航到搜索页面展示结果
                if (this.$route.path !== "/search") {
                    this.$router.push("/search?s=");
                }
                // this.$P.$emit("updateSearchFn", "");
            } catch (error) {
                console.error("获取最新素材失败:", error);
                this.updateAllCardList([]);
                this.updateAllCardListMeta({});
            }  finally {
                this.isLoadingLatest = false; // 请求完成或失败后重置状态
            }
        },
        on_toggle_search_input() {
            window.event ? (window.event.cancelBubble = true) : event.stopPropagation();
            this.searchMove = false;
            $(this.$refs.headerSearchBox).addClass("header-sear-active");
            $(this.$refs.searchBigBox).addClass(this.headerSearActive);
            $(".v-application--wrap").on("click", () => {
                this.searchMove = true;
                this.keyword = "";
                $(this.$refs.searchBigBox).removeClass(this.headerSearActive);
                $(this.$refs.categoryList).removeClass(this.sreachActive);
                $(this.$refs.headerSearchBox).removeClass("header-sear-active");
            });
        },
        // 侧边栏
        on_toggle_menu() {
            // 先保存当前图片数据
            const currentImages = [...this.allCardList];
            
            // 清空瀑布流
            this.updateAllCardList([]);
            
            // 执行菜单切换
            this.isMenuHide = !this.isMenuHide;
            window.document.body.classList.toggle("menu-hide");
            
            // 延迟重新加载图片
            setTimeout(() => {
                this.updateAllCardList(currentImages);
            }, 400);
        },
        search_big_box_close() {
            window.event ? (window.event.cancelBubble = true) : event.stopPropagation();
            this.searchMove = true;
            $(this.$refs.headerSearchBox).removeClass("header-sear-active");
            $(this.$refs.searchBigBox).removeClass(this.headerSearActive);
            this.keyword = "";
        },

        search_big_box_show() {
            window.event ? (window.event.cancelBubble = true) : event.stopPropagation();
        },

        load_search_page() {
            if (this.$route.path.indexOf("/search") > -1) {
                this.$P.$emit("updateSearchFn", this.$route.query.s);
            }
        },
         // 选择日期
        on_chang_time_type() {
            if (this.timeModel.value == "customize") {
                $(this.$refs.chooseTimeBox).addClass(this.headerSearActive);
            } else {
                $(this.$refs.chooseTimeBox).removeClass(this.headerSearActive);
            }
        },
        //选择分类
        on_click_category_btn() {
            window.event ? (window.event.cancelBubble = true) : event.stopPropagation();
            $(this.$refs.categoryList).addClass(this.sreachActive);
            $(this.$refs.searchBigBox).on("click", () => {
                $(this.$refs.categoryList).removeClass(this.sreachActive);
            });
        },
         // 点击下拉列表中的不限位置chexkbox
        on_change_all_checked() {
            if (this.isUnlimited) {
                this.selection = [];
            }
        },

        on_checked_item(arr) {
            this.updateLv1_ID(arr);
            if (arr.length) {
                this.isUnlimited = false;
            } else {
                this.isUnlimited = true;
            }
        },

        search_change_show(event) {
            window.event ? (window.event.cancelBubble = true) : event.stopPropagation();
            $(this.$refs.categoryList).addClass(this.sreachActive);
        },

        async on_export() {
            this.exporting = true;
            const params = {
                type: this.SearchTypeSelect,
                driveIds: this.driveIdsID || [],
                lv1_categories: this.lv1_ID || [],
                lv2_categories: this.GLOBAL.activeLv2Id,
                keyword: this.keyword,
                orderby: this.sequenceType,
                order: "desc",
                page: this.GLOBAL.scrollPage,
                per_page: 80,
                download_start: this.download_start,
                download_end: this.download_end,
                start: this.starTime,
                end: this.endTime,
            };
            let qsStr = qs.stringify({ ...params });
            let link = `/api/export?${qsStr}`;
            try {
                await get_api_data("GET", "export", params);
                window.open(link, "_blank");
            } catch (e) {
                if (!~e.toString().indexOf("400")) {
                    window.location.href = link;
                }
            }
            this.exporting = false;
        },

        on_reset_search_filter() {
            this.isDisabledSearch = true;
            this.keyword = "";
            this.download_start = 0;
            this.download_end = MAX_DOWNLOAD_END;
            this.updateStarTime("");
            this.updateSearchTypeSelect("all");
            this.timeModel = { value: "all" };
            this.selection = [];
            $(this.$refs.chooseTimeBox).removeClass(this.headerSearActive);
            this.isUnlimited = true;
        },
         //  点击搜索
        on_click_search_btn() {
            window.event ? (window.event.cancelBubble = true) : event.stopPropagation();
            if (this.keyword.trim()) {
                // 处理路由
                const path = `/search?s=${this.keyword}`;
                if (this.$route.path !== path) this.$router.push(path);
                // 清空列表页选中的图片（批量操作）
                this.updateAllCardList("");
                this.updateAllCardListMeta("");
                switch (this.timeModel.value) {
                    case "customize":
                        this.updateStarTime(this.trip.start);
                        this.updateEndTime(this.trip.end || this.nowadays);
                        break;
                    case "monthTime":
                        this.updateStarTime(this.monthTime);
                        this.updateEndTime(this.nowadays);
                        break;
                    case "weekTime":
                        this.updateStarTime(this.weekTime);
                        this.updateEndTime(this.nowadays);
                        break;
                    case "nowadays":
                        this.updateStarTime(this.nowadays);
                        this.updateEndTime(this.nowadays);
                        break;
                    case "yesterday":
                        this.updateStarTime(this.yesterday);
                        this.updateEndTime(this.yesterday);
                        break;
                    default:
                        this.updateStarTime("");
                        this.updateEndTime("");
                        break;
                }
                this.updateSearchTypeSelect(this.SearchTypeSelect);
                this.updateTypeSelect(this.SearchTypeSelect);
                this.updateKeyword(this.keyword);
                this.updateDownloadStart(this.download_start);
                this.updateDownloadEnd(this.download_end);
                if (this.isUnlimited) {
                    this.updateDriveIdsID([]);
                    this.updateLv1_ID([]);
                    this.GLOBAL.activeLv2Id = "";
                    this.GLOBAL.searchResultModel = 0;
                }
                this.GLOBAL.scrollPage = 1;
                this.get_search_result(this.GLOBAL.scrollPage);
            } else {
                this.isDisabledSearch = true;
            }
            $(this.$refs.searchBigBox).removeClass(this.headerSearActive);
            this.searchMove = true;
            $(this.$refs.headerSearchBox).removeClass("header-sear-active");
            if (this.allCardListMeta.last_page == 1) {
                this.loadAll = true;
            }
        },
         //  获取搜索结果
        async get_search_result(event) {
            this.searchResult = await get_api_data("GET", "search", {
                driveIds: this.driveIdsID || [],
                lv1_categories: this.lv1_ID || [],
                lv2_categories: this.GLOBAL.activeLv2Id,
                type: this.SearchTypeSelect,// all  image  video
                start: this.starTime,//2021-04-15
                end: this.endTime,//2021-04-15
                keyword: this.keyword,
                scenes: this.churchLifeModel,
                orderby: this.sequenceType, // createdTime  name downloads  likes
                order: "desc",
                download_start: this.download_start,
                download_end: this.download_end,
                per_page: 80,
                page: event,
            });
            this.updateAllCardList(this.searchResult.data.data);
            this.updateAllCardListMeta(this.searchResult.data.meta);
            this.isGetData = false;
        },
        // 悬浮导航
        on_menu_scroll() {
            let newScrollTop = window.pageYOffset;
            let diffScroll = newScrollTop - this.oldScrollTop;
            let transparency = 0;
            this.oldScrollTop = newScrollTop;
            transparency = this.oldScrollTop / 100;
            if (newScrollTop > 80) {
                if (transparency === 0 || transparency < 1) {
                    transparency = 0;
                    $("#header-1").removeClass("header-1-active");
                }
                if (diffScroll < 0 || diffScroll == 0) {
                    $("#header-1").removeClass("header-1-active");
                } else {
                    $("#header-1").addClass("header-1-active");
                }
            } else {
                $("#header-1").removeClass("header-1-active");
            }
        },
         //  处理日期格式化
        time_change_show() {
            let getDays = () => {
                //构造当前日期对象
                let date = new Date();
                let year = date.getFullYear(); //获取年份
                let mouth = date.getMonth() + 1; //获取当前月份
                let days; //定义当月的天数；
                if (mouth == 2) {
                    //当月份为二月时，根据闰年还是非闰年判断天数
                    days = year % 4 == 0 ? 29 : 28;
                } else if (mouth == 1 || mouth == 3 || mouth == 5 || mouth == 7 || mouth == 8 || mouth == 10 || mouth == 12) {
                    //月份为：1,3,5,7,8,10,12 时，为大月则天数为31;
                    days = 31;
                } else {
                    //其他月份为小月，天数为30;
                    days = 30;
                }
                return days;
            };
            Date.prototype.Format = function (fmt) {
                var o = {
                    "M+": this.getMonth() + 1, //月份
                    "d+": this.getDate(), //日
                    "h+": this.getHours(), //小时
                    "m+": this.getMinutes(), //分
                    "s+": this.getSeconds(), //秒
                    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
                    "S+": this.getMilliseconds(), //毫秒
                };
                if (/(y+)/.test(fmt))
                    fmt = fmt.replace(
                        RegExp.$1,
                        (this.getFullYear() + "").substr(4 - RegExp.$1.length)
                    );
                for (var k in o)
                    if (new RegExp("(" + k + ")").test(fmt))
                        fmt = fmt.replace(
                            RegExp.$1,
                            RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
                        );
                return fmt;
            };
            let oNow = new Date();
            this.nowadays = new Date().Format("yyyy-MM-dd"); //把当前日期转换为所需要的格式
            let weekdateDiff = 604800000; //一周时间差的毫秒数 计算公式： 7*24*3600*1000
            this.weekTime = new Date(oNow.getTime() - weekdateDiff).Format("yyyy-MM-dd");
            let monthdateDiff = getDays() * 24 * 3600 * 1000;
            this.monthTime = new Date(oNow.getTime() - monthdateDiff).Format("yyyy-MM-dd");
            this.yesterday = new Date(oNow.getTime() - 24 * 3600 * 1000).Format("yyyy-MM-dd");
        },
    },
};
</script>

<style lang="scss">
.download-range {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    input {
        width: 100px;
        border: 1.5px solid #d5e8e3;
        border-radius: 8px;
        padding: 4px 12px;
        background: #f4f9f8;
        color: #0f2922;
        outline: none;
        transition: border-color 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;
        &:focus {
            background: #ffffff;
            border-color: #10b981;
            box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.16);
        }
    }
    span {
        display: block;
        padding: 0 12px;
        opacity: 0.4;
    }
}

/* 顶部导航栏右侧用户胶囊与退出登录下拉菜单样式 */
.header-user-area {
    display: flex;
    align-items: center;
    margin-left: 16px;
}

.header-user-divider {
    width: 1px;
    height: 22px;
    background: rgba(255, 255, 255, 0.24);
    margin-right: 16px;
}

.user-capsule-btn {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    height: 40px;
    padding: 0 14px 0 6px;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.14);
    border: 1px solid rgba(255, 255, 255, 0.24);
    color: #ffffff;
    cursor: pointer;
    outline: none;
    transition: background-color 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;

    &:hover {
        background: rgba(255, 255, 255, 0.22);
        border-color: rgba(255, 255, 255, 0.38);
    }

    &:focus-visible {
        box-shadow: 0 0 0 3px rgba(52, 211, 153, 0.45);
    }

    .user-avatar-badge {
        width: 28px;
        height: 28px;
        border-radius: 50%;
        background: linear-gradient(135deg, #34d399 0%, #059669 100%);
        color: #042f2e;
        font-size: 13px;
        font-weight: 700;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.18);
    }

    .user-name-text {
        font-size: 14px;
        font-weight: 600;
        color: #ffffff;
        max-width: 120px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .user-caret-icon {
        color: rgba(255, 255, 255, 0.85) !important;
        margin-left: -2px;
    }
}

.user-dropdown-menu {
    border-radius: 14px !important;
    box-shadow: 0 16px 36px -8px rgba(4, 31, 23, 0.28),
                0 0 0 1px rgba(16, 105, 81, 0.08) !important;
    margin-top: 8px;
    overflow: hidden;
}

.user-menu-card {
    min-width: 220px;
    background: #ffffff;
    padding: 8px;
}

.user-menu-header {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 10px 12px;
}

.user-menu-avatar {
    width: 38px;
    height: 38px;
    border-radius: 50%;
    background: linear-gradient(135deg, #106951 0%, #188c6c 100%);
    color: #ffffff;
    font-size: 15px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.user-menu-info {
    min-width: 0;
    flex: 1;
}

.user-menu-name {
    font-size: 14px;
    font-weight: 700;
    color: #0f241d;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.user-menu-email {
    font-size: 12px;
    color: #64748b;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-top: 2px;
}

.user-menu-divider {
    height: 1px;
    background: #eef2f0;
    margin: 4px 6px 6px;
}

.user-logout-btn {
    width: 100%;
    min-height: 42px;
    padding: 8px 12px;
    border: none;
    border-radius: 10px;
    background: transparent;
    color: #dc2626;
    font-size: 14px;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;
    transition: background-color 0.18s ease, color 0.18s ease;

    .logout-icon {
        color: #dc2626 !important;
    }

    &:hover:not(:disabled) {
        background: #fef2f2;
        color: #b91c1c;
        .logout-icon {
            color: #b91c1c !important;
        }
    }

    &:focus-visible {
        outline: 2px solid #dc2626;
        outline-offset: -2px;
    }

    &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }
}
</style>